<template>
	<div
		class="flex flex-col gap-12 items-center justify-center"
	>
		<AtomButton
			size="lg"
			:variant="ButtonVariant.Yellow"
			icon-left="fa-calendar-days"
			:text="appointmentButtonText ?? 'Afspraak maken'"
			@click="openAppointmentDialog"
		/>
		<div class="flex flex-col justify-center items-center gap-6">
			<p
				v-if="textInBetween"
				class="text-paragraph-size-md text-gray-700 text-center"
			>
				{{ textInBetween ?? 'Of bel ons voor een afspraak' }}
			</p>
			<AtomButton
				class="cursor:hidden"
				:to="phoneLink"
				:variant="ButtonVariant.Green"
				icon-left="fa-phone"
				:text="phoneButtonText ?? 'Telefonisch afspraak maken'"
				size="lg"
				@click="trackClickToCall('CallToContact_bellen_mobiel', 30)"
			/>
			<AtomButton
				tabindex="1"
				class="touch:hidden text-purple-600"
				:to="phoneLink"
				size="lg"
				:variant="ButtonVariant.Transparent"
				icon-left="fa-phone"
				:text="phoneNumber"
				@click="trackClickToCall('CallToContact_bellen_desktop', 30)"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { phoneNumber } from '#base/core/consts/companyData';
import { phoneLink } from '#base/core/consts/links';
import { ButtonVariant } from '#base/core/enums/ButtonVariantEnum';

const {
	trackClickToCall,
} = useEventTracking();
const {
	openAppointmentDialog,
} = useDialogs();

const {
	textInBetween = 'Of bel ons voor een afspraak',
} = defineProps<{
	textInBetween?: string;
	appointmentButtonText?: string;
	phoneButtonText?: string;
}>();
</script>
